export { default } from "./MainFooter";
